<div class="actions-container">
  <ng-casto-button
    [label]="'need_mapping.no_choice.info' | translate"
    class="secondary"
    (click)="selectStyle(0)"></ng-casto-button>
</div>
<ul class="inspiration-items">
  @for (style of datas.styles; track style) {
    <li [class.active]="current.kitchen.styleId === style.id">
      <figure (click)="selectStyle(style.id)">
        <span class="media">
          <img *ngIf="style.img !== ''" [src]="'assets/img/' + style.img" [alt]="style.title" />
          <span class="title-overlay">
            {{ style.titleRef | translate }}
          </span>
          <span class="state">
            <svg class="icon-action-select-thumb" aria-hidden="true">
              <use
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xlink:href="assets/img/icons.svg#icon-action-select-thumb"></use>
            </svg>
          </span>
        </span>
      </figure>
    </li>
  }
</ul>
